import React, { useState } from 'react';
import AIChatPanel from './AIChatPanel';

const BRAND      = '#2b5a7e';
const BRAND_DARK = '#214561';

const AIAssistantButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <style>{FAB_CSS}</style>

      {/* FAB — fades/shrinks away when panel is open */}
      <button
        className="ai-fab"
        style={{ opacity: open ? 0 : 1, pointerEvents: open ? 'none' : 'auto', transform: open ? 'scale(0.8) translateY(8px)' : 'scale(1) translateY(0)' }}
        onClick={() => setOpen(true)}
        title="Open AI Assistant"
        aria-label="Open AI Assistant"
      >
        <span className="ai-fab-pulse" />
        <i className="bx bxs-star" style={{ fontSize: 17 }} />
        <span style={{ letterSpacing: 0.3 }}>AI Assistant</span>
      </button>

      <AIChatPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
};

const FAB_CSS = `
  @keyframes aiFabPulse {
    0%   { transform: scale(1);    opacity: 0.45; }
    70%  { transform: scale(1.35); opacity: 0;    }
    100% { transform: scale(1.35); opacity: 0;    }
  }

  .ai-fab {
    position: fixed; bottom: 24px; right: 24px; z-index: 1040;
    display: flex; align-items: center; gap: 8px;
    padding: 12px 20px;
    background: linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%);
    color: #fff; border: none; border-radius: 999px;
    cursor: pointer; font-size: 13px; font-weight: 600;
    font-family: inherit; letter-spacing: 0.2px;
    box-shadow: 0 4px 20px rgba(43,90,126,0.4);
    transition: transform 0.22s ease, box-shadow 0.22s ease, opacity 0.2s ease;
  }
  .ai-fab:hover {
    transform: scale(1.05) translateY(-2px) !important;
    box-shadow: 0 8px 28px rgba(43,90,126,0.5) !important;
  }
  .ai-fab:active { transform: scale(0.97) translateY(0) !important; }

  .ai-fab-pulse {
    position: absolute; inset: 0; border-radius: 999px;
    background: rgba(43,90,126,0.45);
    animation: aiFabPulse 2.6s cubic-bezier(0.4,0,0.6,1) infinite;
    pointer-events: none;
  }
`;

export default AIAssistantButton;
